import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { THEME } from '../../../core/constants'

const viewTypeBannerConfig = {
  DEFINE: {
    color: THEME.colors.taskViewDefine,
    text: 'You are in Define view',
  },
  QC: {
    color: THEME.colors.taskViewQc,
    text: 'You are in QC view',
  },
  QQA: {
    color: THEME.colors.taskViewQqa,
    text: 'You are in QQA view',
  },
}

const Banner = styled.div`
  position: sticky;
  top: 0;
  z-index: 1000;
  background: ${({ color }) => color};
  color: #fff;
  text-align: center;
  font-weight: 600;
  font-size: 18px;
  padding: 8px 0;
  letter-spacing: 0.5px;
  margin-top: 8px;
`

const TaskViewBanner = ({ currentViewType }) => {
  const bannerConfig = viewTypeBannerConfig[currentViewType] || null
  if (!bannerConfig) return null
  return <Banner color={bannerConfig.color}>{bannerConfig.text}</Banner>
}

TaskViewBanner.propTypes = {
  currentViewType: PropTypes.string,
}

TaskViewBanner.defaultProps = {
  currentViewType: undefined,
}

export default TaskViewBanner
